import { Injectable } from '@angular/core';
import { WeeeSubmitRequest, WeeeSuccess } from '~shared/modules/weee-landing-page/models/weee-feedback.model';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { API_WEEE_REQUEST_ROUTE } from '~shared/modules/weee-landing-page/constants/api.constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WeeeFeedbackService {
  constructor(private http: HttpClient) {}

  submitUserSelection(payload: WeeeSubmitRequest): Observable<WeeeSuccess> {
    const weeeUrl = `${API_WEEE_REQUEST_ROUTE()}/${payload.action}/${payload.id}`;
    return this.http.get(weeeUrl).pipe(
      map((response) => ({status: payload.action}))
    );
  }
}
